import React, { Component } from "react";

import {
  Card,
  Button,
  Table,
  Modal,
  Select,
  Input,
  Tag,
  message,
  BackTop,
  Checkbox,
} from "antd";

import { connect } from "react-redux";
import {
  req_page_gam_graduateFresh,
  req_downloadfile_gam_graduateFresh,
  req_delete_gam_graduateFresh,
} from "../../api";
//import { formateDate } from '../../utils/dateUtil'
import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";

import GraduateSingle from "./graduate-single-modal";

import "./graduatefresh.css";
class GraduateManage extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    userLevel: "NORMAL",
    loading: false,
    item: {},
    items: [],
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "None",
    searchValue: "",
    filterStatus: "",

    domnloadFile: "",
    isShowModal: false,
    isTutorModal: false,
    descriptionText: new Date().getMonth() + 1 > 6 ? "畢業後現況" : "未來規劃",
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      isTutorModal,
    } = this.state;
    const { token, userCode, role } = this.props.user;
    // console.log(isTutorModal);
    var userLevel = usrRole(role);
    if (!isTutorModal) {
      this.setState({ userLevel: userLevel });
    } else {
      userLevel = "TUTOR";
    }

    this.setState({ loading: true, items: [] });
    const result = await req_page_gam_graduateFresh(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token
    );
    this.setState({ loading: false });

    //console.log(result)
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
  };

  api_downloadfile_items = async () => {
    const { searchField, searchValue, filterStatus, isTutorModal } = this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    if (!isTutorModal) {
      this.setState({ userLevel: userLevel });
    } else {
      userLevel = "TUTOR";
    }
    // download file data
    const fileUrl = await req_downloadfile_gam_graduateFresh(
      userCode,
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "畢業生清單";
    a.click();
  };

  api_delete_item = async (item) => {
    const { Uid } = item;
    const { token } = this.props.user;
    const result = await req_delete_gam_graduateFresh(Uid, token);
    if (result.status === "success") {
      message.success("刪除成功");
      this.api_page_items(this.current);
    } else {
      //console.log(result)
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    const { descriptionText } = this.state;
    this.columns = [
      {
        title: "部別",
        dataIndex: "Division",
        width: 60,
        responsive: ["lg"],
      },
      {
        title: "學院",
        dataIndex: "CollegeName",
        width: 60,
        responsive: ["md"],
      },
      {
        title: "系所",
        dataIndex: "DepartmentName",
        width: 60,
        responsive: ["md"],
      },
      {
        title: "班級",
        dataIndex: "ClassGradeName",
        width: 65,
      },
      {
        title: "學號",
        dataIndex: "StudentId",
        width: 60,
        responsive: ["lg"],
      },
      {
        title: "姓名",
        dataIndex: "StudentName",
        width: 60,
      },
      {
        title: descriptionText,
        dataIndex: "",
        responsive: ["lg"],
        width: 60,
        render: (item) => {
          const { PlanStatusPrimary, Uid } = item;
          let color = this.style_switch_color_tag(
            "PlanStatusPrimary",
            PlanStatusPrimary
          );
          return (
            <>
              <Tag color={color} key={Uid}>
                {PlanStatusPrimary}
              </Tag>
            </>
          );
        },
      },
      // {
      //   title: "就業說明",
      //   dataIndex: "",
      //   responsive: ["lg"],
      //   width: 60,
      //   render: (item) => {
      //     const { PlanStatusPrimary, JobType, Uid } = item;
      //     return (
      //       <>
      //         {PlanStatusPrimary !== "就業" ? (
      //           <Tag color={"blue"} key={Uid}>
      //             未就業
      //           </Tag>
      //         ) : JobType === "" ? (
      //           <Tag color={"red"} key={Uid}>
      //             未填
      //           </Tag>
      //         ) : (
      //           <Tag color={"green"} key={Uid}>
      //             {JobType}
      //           </Tag>
      //         )}
      //       </>
      //     );
      //   },
      // },
      {
        title: () => (
          <span>
            <span className="element-hidden">調查</span>狀態
          </span>
        ),
        filters: [
          { text: "已回報", value: "YES" },
          { text: "未回報", value: "NO" },
        ],
        filterMultiple: false,
        width: 60,
        render: (item) => {
          const { ConfirmStatus, Uid } = item;
          let color = this.style_switch_color_tag(
            "ConfirmStatus",
            ConfirmStatus
          );
          return (
            <>
              <Tag color={color} key={Uid}>
                {ConfirmStatus === "NO" ? "未回報" : "已回報"}
              </Tag>
            </>
          );
        },
      },
      {
        title: "",
        dataIndex: "",
        width: 65,
        render: (item) => {
          const { ConfirmStatus } = item;
          const { userLevel } = this.state;
          return (
            <>
              <Button
                type="dashed"
                size="small"
                style={{
                  color: ConfirmStatus === "NO" ? "DarkBlack" : "Green",
                }}
                onClick={() => this.handle_show_ui_singleGraduate(item)}
                block
              >
                <i className="far fa-address-card element-hidden"></i>{" "}
                <span>檢視</span>
              </Button>
              {userLevel === "MANAGER" ? (
                <Button
                  type="dashed"
                  style={{ color: "Red" }}
                  size="small"
                  onClick={() => this.handle_delete_ui_singleGraduate(item)}
                  block
                >
                  <i className="fas fa-user-slash"></i> <span>刪除</span>
                </Button>
              ) : (
                ""
              )}
            </>
          );
        },
      },
    ];
  };

  style_switch_color_tag(column, param) {
    if (column === "PlanStatusPrimary") {
      switch (param) {
        case "尚待確認":
          return "red";
        case "就業":
        case "服役":
        case "升學":
        case "留學":
          return "green";
        case "其他":
          return "purple";
        default:
          return "default";
      }
    }
    if (column === "ConfirmStatus") {
      switch (param) {
        case "NO":
          return "red";
        case "YES":
          return "green";
        default:
          return "default";
      }
    }
  }
  // 操作互動處理 //////////////////////////////////////////////

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_download = () => {
    this.api_downloadfile_items();
  };

  handle_show_ui_singleGraduate = (item) => {
    this.setState({ isShowModal: true, item });
  };

  handle_delete_ui_singleGraduate = (item) => {
    Modal.confirm({
      title: `您確定刪除${item.StudentName}用戶`,
      onOk: () => {
        this.api_delete_item(item);
      },
    });
  };

  handle_onTutorStatus = (e) => {
    //console.log(`checked = ${e.target.checked}`);
    this.setState({ isTutorModal: e.target.checked }, () =>
      this.api_page_items(1)
    );
  };
  /////////////////////////////////////////////////////////////

  render() {
    const {
      loading,
      userLevel,
      item,
      items,
      pagination,
      searchField,
      searchValue,
      isShowModal,
    } = this.state;
    const title = (
      <span>
        <Select
          value={searchField}
          style={{ width: 110 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="None">搜索條件</Select.Option>
          <Select.Option value="ClassGradeName">班級</Select.Option>
          <Select.Option value="StudentId">畢業生學號</Select.Option>
          <Select.Option value="StudentName">畢業生姓名</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 140, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i>
          <span>查詢</span>
        </Button>{" "}
        <Button type="primary" onClick={() => this.handle_data_download()}>
          <i className="fas fa-cloud-download-alt element-hidden"></i>
          <span>下載</span>
        </Button>
        {userLevel === "MANAGER" ? (
          <Checkbox
            style={{ margin: "0 5px" }}
            onChange={(e) => this.handle_onTutorStatus(e)}
          >
            導師模式
          </Checkbox>
        ) : (
          ""
        )}
      </span>
    );
    return (
      <Card title={title}>
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="Uid"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
        <Modal
          destroyOnClose={true}
          title="基本資料"
          visible={isShowModal}
          width={1000}
          onOk={() => {
            this.setState({ isShowModal: false });
          }}
          onCancel={() => {
            this.setState({ isShowModal: false });
          }}
        >
          <GraduateSingle graduate={item} />
        </Modal>
        <BackTop visibilityHeight="80" />
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(GraduateManage);
